// AUTO-GENERATED - Do not manually edit this file
// This file is generated by scripts/devlink/config-generator/generate-props-config.js
import { FIELD_TYPES } from "../../../../../../constants/template-field-type";
export default {
    forresterLinkText: {
        type: FIELD_TYPES.TEXT,
        label: "Forrester Link Text",
        translatable: true
    },
    forresterText: {
        type: FIELD_TYPES.TEXT,
        label: "Forrester Text",
        translatable: true
    },
    g2Text: {
        type: FIELD_TYPES.TEXT,
        label: "G 2 Text",
        translatable: true
    },
    gartnerLinkText: {
        type: FIELD_TYPES.TEXT,
        label: "Gartner Link Text",
        translatable: true
    },
    gartnerText: {
        type: FIELD_TYPES.TEXT,
        label: "Gartner Text",
        translatable: true
    },
    title: {
        type: FIELD_TYPES.TEXT,
        label: "Title",
        translatable: true
    },
    forresterLink: {
        type: FIELD_TYPES.NESTED,
        label: "Forrester Link",
        fields: {
            href: {
                type: FIELD_TYPES.TEXT,
                label: "URL",
                translatable: true
            },
            target: {
                type: FIELD_TYPES.TEXT,
                label: "Target",
                translatable: false
            }
        }
    },
    gartnerLinkLink: {
        type: FIELD_TYPES.NESTED,
        label: "Gartner Link Link",
        fields: {
            href: {
                type: FIELD_TYPES.TEXT,
                label: "URL",
                translatable: true
            },
            target: {
                type: FIELD_TYPES.TEXT,
                label: "Target",
                translatable: false
            }
        }
    }
};
